import { useState } from "react";
import { Box, Input, FormControl, Pressable } from "native-base";
import InputErrorMessage from "../inputErrorMessage";
import Svg from "react-native-svg";
import { passwordCloseIconSVG, passwordOpenIconSVG } from "../../utils/svg";

const NewInputField = ({
  name = "input",
  label = "",
  value = "",
  defaultValue = "",
  type = "text",
  width = "auto",
  isInvalid = false,
  isDisabled = false,
  errorMessage = "Enter details",
  placeholder = "",
  onChange = () => {},
  important = false,
}) => {
  const [show, setShow] = useState(false);

  return (
    <Box>
      <FormControl isInvalid={isInvalid} isDisabled={isDisabled} w={width}>
        {label && (
          <FormControl.Label>
            {label} {important && <span> *</span>}
          </FormControl.Label>
        )}
        <Input
          name={name}
          value={value}
          defaultValue={defaultValue}
          size="20"
          type={type === "password" ? (show ? "text" : "password") : type}
          placeholder={placeholder}
          onChange={(e) => onChange(e, name)}
          style={{ fontSize: "14", height: "36px" }}
          InputRightElement={
            type === "password" && (
              <Pressable onPress={() => setShow(!show)} pr={3}>
                {show ? (
                  <Svg width="24" height="24" viewBox="0 0 24 24">
                    {passwordOpenIconSVG}
                  </Svg>
                ) : (
                  <Svg width="24" height="24" viewBox="0 0 24 24">
                    {passwordCloseIconSVG}
                  </Svg>
                )}
              </Pressable>
            )
          }
        />
        {isInvalid && <InputErrorMessage errorMessage={errorMessage} />}
      </FormControl>
    </Box>
  );
};

export default NewInputField;
